export default (context, inject) => {
  const sortBy = (list, key, direction = 1) => [...list].sort((a, b) => direction * ((a[key] > b[key]) ? -1 : 1));
  inject('sortBy', sortBy);
  context.$sortBy = sortBy;
};
